export function getApiErrorMessage(error, fallbackMessage) {
  // Sin respuesta del servidor (error de red, CORS, etc.)
  if (!error || !error.response || !error.response.data) {
    return fallbackMessage;
  }

  const data = error.response.data;

  // 1. Nuevo formato Laravel: { ok, message, error: { code, message, details }, errors }
  if (typeof data.message === 'string' && data.message.trim().length > 0) {
    return data.message;
  }

  if (data.error?.message) {
    return data.error.message;
  }

  // 2. Validaciones: tomar primer mensaje de errors o error.details
  const errors = data.errors || data.error?.details;
  if (errors && typeof errors === 'object') {
    const firstFieldErrors = Object.values(errors)[0];
    if (Array.isArray(firstFieldErrors) && firstFieldErrors.length > 0) {
      return firstFieldErrors[0];
    }
    if (typeof firstFieldErrors === 'string') {
      return firstFieldErrors;
    }
  }

  // 3. Formato antiguo Python/FastAPI: { detail: "..." }
  if (typeof data.detail === 'string' && data.detail.trim().length > 0) {
    return data.detail;
  }

  // 4. Fallback al mensaje del propio error de Axios
  if (error.message) {
    return error.message;
  }

  return fallbackMessage;
}

